import { ArrowUpRight } from "lucide-react";
import { SERVICES } from "@/lib/site-data";

export default function Services() {
  return (
    <section id="services" className="py-20 md:py-28" data-testid="services-section">
      <div className="container-site">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14">
          <div className="max-w-2xl">
            <p className="overline mb-3">What we do at home</p>
            <h2 className="font-serif text-4xl md:text-5xl text-brand-pine leading-tight">
              Home visit doesn't mean <span className="italic text-brand-clay">basic care.</span>
            </h2>
            <p className="mt-4 text-brand-textMuted leading-relaxed">
              From digital X-rays to root canals to full-mouth rehabilitation —
              we bring real, modern dentistry to your living room.
            </p>
          </div>
          <a href="#booking" className="btn-outline self-start md:self-end" data-testid="services-book-btn">
            Book a service
          </a>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {SERVICES.map((s, i) => (
            <article
              key={s.slug}
              data-testid={`service-card-${s.slug}`}
              className="group bg-white rounded-2xl border border-brand-line/60 overflow-hidden hover:-translate-y-1 hover:shadow-xl transition-all duration-300 flex flex-col"
            >
              <div className="relative aspect-[16/10] overflow-hidden">
                <img
                  src={s.image}
                  alt={s.title}
                  loading="lazy"
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <span className="absolute top-4 left-4 bg-white/90 backdrop-blur text-xs font-medium text-brand-pine px-3 py-1 rounded-full">
                  {String(i + 1).padStart(2, "0")}
                </span>
              </div>
              <div className="p-6 flex flex-col flex-1">
                <h3 className="font-serif text-2xl text-brand-pine mb-2">{s.title}</h3>
                <p className="text-sm text-brand-textMuted leading-relaxed flex-1">{s.desc}</p>
                <a
                  href="#booking"
                  data-testid={`service-book-${s.slug}`}
                  className="mt-5 inline-flex items-center gap-2 text-sm font-medium text-brand-clay hover:gap-3 transition-all"
                >
                  Book this <ArrowUpRight size={16} />
                </a>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
